import loaderDark from '../../../assets/icons/loaderDark.gif';

type ChatVisualizationLoaderProps = {
  title?: string;
};

export default function ChatVisualizationLoader({
  title,
}: ChatVisualizationLoaderProps) {
  return (
    <div className="mt-2 overflow-hidden rounded-md border border-taupe-300 bg-white">
      {title && (
        <div className="border-b border-taupe-200 bg-taupe-50 px-3 py-2 text-xs font-semibold text-black-800">
          {title}
        </div>
      )}
      <div className="flex h-52 flex-col items-center justify-center gap-3 bg-taupe-50/60 px-4">
        <img src={loaderDark} alt="Loading chart" className="h-8 w-8 rounded-full" />
        <p className="text-xs text-black-500">Loading visualization...</p>
        <div className="flex h-16 w-full items-end justify-center gap-2 px-4">
          {[40, 64, 48, 72, 56, 80].map((height, index) => (
            <div
              key={index}
              className="w-4 animate-pulse rounded-sm bg-taupe-200"
              style={{ height }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
